export default class ExpiredAccountError {
    constructor () {
        Error.apply(this, []);
    }
}
